
import RouteItem from './Routes/RouteItem';



function App() {


  return (
    <div className="App">
      <RouteItem/>   
    </div>
  );
}

export default App;
